import React from "react"
import './WaveStyles.css'

const WaveBackground = ({ backgroundUrl }) => {
    return (
        <div id="wave-background" className='image-section' style={{ backgroundImage: `url(${backgroundUrl})` }}></div>
    )
}
export default WaveBackground